import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PUT_DISABLE_MEDICAL_CONDITIONS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutDisableMedicalConditions = ({onSuccess, onError}: Input = {}) => {
  const putDisableMedicalConditions = async (uuid: string) => {
    await axiosClient.put(PUT_DISABLE_MEDICAL_CONDITIONS_URL(uuid));
  };

  return useCustomMutation(putDisableMedicalConditions, {
    onSuccess,
    onError,
  });
};
